module.exports = {"classes":["privacy-page","header-dark"],"title":"Privacy Policy","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy/metadata.json
// module id = 1558
// module chunks = 0